var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._l((_vm.roles),function(role){return _c('v-chip',{key:role,staticClass:"mr-2"},[_vm._v(_vm._s(role))])}),(_vm.value.length > _vm.displayCount)?_c('v-chip',[_vm._v("+ "+_vm._s(_vm.value.length - _vm.displayCount))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }